export enum CustomerTypes {
  PRIVATE = 1,
  CORPORATE = 2,
}

export const customerTypesLabels = new Map<number, string>([
  [CustomerTypes.PRIVATE, "CUSTOMERS.VIEW.CUSTOMER_TYPE_PRIVATE"],
  [CustomerTypes.CORPORATE, "CUSTOMERS.VIEW.CUSTOMER_TYPE_CORPORATE"],
]);
